/**
 * Nested T-Hangar (Interleaving/Zipper) Template
 *
 * Two T-hangar rows with tails interlocking in a shared middle zone.
 * Row A: N units all south-facing. Row B: N-1 units all north-facing, shifted half-pitch.
 */

import { Grid3X3 } from 'lucide-react'
import type { BuildingTemplate } from '../types'
import { nestedTHangarParamsSchema, DEFAULT_NESTED_T_HANGAR_VALUES, type NestedTHangarParams } from './params'
import { generateBuilding, generateUnits } from './generate'

export const NestedTHangarTemplate: BuildingTemplate<NestedTHangarParams> = {
  id: 'nested_t_hangar',
  name: 'Nested T-Hangar',
  description: 'Interlocking T-hangar rows with zipper tail pattern',
  icon: Grid3X3,
  buildingType: 'nested_t_hangar_row',

  generateBuilding,
  generateUnits,

  formSchema: nestedTHangarParamsSchema,
  defaultValues: DEFAULT_NESTED_T_HANGAR_VALUES,
}

// Re-export types and utilities
export { type NestedTHangarParams, type EndSpaceMode, nestedTHangarParamsSchema, DEFAULT_NESTED_T_HANGAR_VALUES } from './params'
export { calculateStepWidth, calculateTShapeArea, calculateNestedUnitPitch } from './params'
export { generateBuilding, generateUnits } from './generate'
export {
  calculateBuildingDepth,
  calculateBuildingWidth,
  calculateRowAOffsets,
  calculateRowBOffsets,
  getRowBCount,
  getTotalUnits,
  calculateEndSpaceDimensions,
  calculateNestedTHangarLayout,
  type NestedTHangarLayoutResult,
} from './calculations'
export { createNestedTHangarEdges } from './edges'
